/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type {
    GetV1ProductgroupsQueryParams,
    GetV1ProductgroupsQueryResponse,
} from '../../types/GetV1Productgroups.ts'

export const getV1ProductgroupsQueryKey = (params?: GetV1ProductgroupsQueryParams) =>
    [{ url: '/v1/ProductGroups' }, ...(params ? [params] : [])] as const

export type GetV1ProductgroupsQueryKey = ReturnType<typeof getV1ProductgroupsQueryKey>

/**
 * {@link /v1/ProductGroups}
 */
export async function getV1Productgroups(
    params?: GetV1ProductgroupsQueryParams,
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1ProductgroupsQueryResponse, ResponseErrorConfig<Error>, unknown>(
        { method: 'GET', url: `/v1/ProductGroups`, params, ...requestConfig },
    )
    return res
}

export function getV1ProductgroupsQueryOptions(
    params?: GetV1ProductgroupsQueryParams,
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ProductgroupsQueryKey(params)
    return queryOptions<
        ResponseConfig<GetV1ProductgroupsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ProductgroupsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Productgroups(params, config)
        },
    })
}

/**
 * {@link /v1/ProductGroups}
 */
export function useGetV1Productgroups<
    TData = ResponseConfig<GetV1ProductgroupsQueryResponse>,
    TQueryData = ResponseConfig<GetV1ProductgroupsQueryResponse>,
    TQueryKey extends QueryKey = GetV1ProductgroupsQueryKey,
>(
    params?: GetV1ProductgroupsQueryParams,
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ProductgroupsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ProductgroupsQueryKey(params)

    const query = useQuery(
        {
            ...getV1ProductgroupsQueryOptions(params, config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
